import { Component, signal, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AddNewValue } from '../add-new-value/add-new-value';

@Component({
  selector: 'app-attribute-list',
  standalone: true,
  imports: [RouterLink, FormsModule, AddNewValue],
  templateUrl: './attribute-list.html',
    styleUrl: './attribute-list.scss',
})
export class AttributeList {
  private router = inject(Router);

  attributesList = signal([
    {
      attributeKey: { titleEn: 'Volume', titleAr: 'الحجم' },
      attributeValues: [
        { id: 1, titleEn: '50 ml', titleAr: '50 مل' },
        { id: 2, titleEn: '100 ml', titleAr: '100 مل' },
        { id: 3, titleEn: '200 ml', titleAr: '200 مل' },
      ],
    },
    {
      attributeKey: { titleEn: 'Form', titleAr: 'الشكل' },
      attributeValues: [
        { id: 4, titleEn: 'Tablets', titleAr: 'أقراص' },
        { id: 5, titleEn: 'Syrup', titleAr: 'شراب' },
        { id: 6, titleEn: 'Capsules', titleAr: 'كبسولات' },
      ],
    },
  ]);

  isModalOpen = signal(false);
  editingIndices = signal<{ attrIdx: number; valIdx: number } | null>(null);
  editData = signal<{ en: string; ar: string } | null>(null);

  openEditValueModal(event: Event, attrIdx: number, valIdx: number) {
    event.preventDefault();
    event.stopPropagation();

    const val = this.attributesList()[attrIdx].attributeValues[valIdx];

    this.editingIndices.set({ attrIdx, valIdx });

    this.editData.set({
      en: val.titleEn,
      ar: val.titleAr,
    });

    this.isModalOpen.set(true);
  }

  handleValueAdded(newValue: { en: string; ar: string }) {
    const indices = this.editingIndices();

    if (indices !== null) {
      this.attributesList.update((list) => {
        const newList = [...list];
        const targetAttr = newList[indices.attrIdx];

        targetAttr.attributeValues[indices.valIdx] = {
          ...targetAttr.attributeValues[indices.valIdx],
          titleEn: newValue.en,
          titleAr: newValue.ar,
        };
        return newList;
      });
    }

    this.isModalOpen.set(false);
    this.editingIndices.set(null);
    this.editData.set(null);
  }

  editAttribute(attr: any) {
    this.router.navigate(['admin/attributes/edit-attribute'], { state: { attribute: attr } });
  }

  removeAttFromTable(index: number) {
    this.attributesList.update((list) => list.filter((_, i) => i !== index));
  }

  deleteAttributeValue(attrIdx: number, valIdx: number) {
    this.attributesList.update((list) => {
      const newList = [...list];
      newList[attrIdx].attributeValues = newList[attrIdx].attributeValues.filter((_, i) => i !== valIdx);
      return newList;
    });
  }
}
